// import { useSelector } from "react-redux";
// import { selectEnums } from "../store/auth";
import { storage } from "../utils/storage";

let warnedMissingEnums = false;

function normalizeEnums(raw) {
  if (raw != null && typeof raw === "object" && !Array.isArray(raw)) {
    return raw;
  }
  if (typeof window !== "undefined" && !warnedMissingEnums) {
    warnedMissingEnums = true;
    console.warn(
      "[UniqueCoop] Application enums are missing or invalid in localStorage (`enums`). " +
        "Form dropdowns may be empty until login finishes and GET /enums returns successfully. " +
        "If this persists after login, check the /enums API response in Network tab."
    );
  }
  return {};
}

export const useEnums = () => {
  // const enums = useSelector(selectEnums);
  const raw = storage["localStorage"].get("enums");
  return normalizeEnums(raw);
};
